"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var field_validation_errors_1 = require("./field-validation-errors");
var label_1 = require("./label");
var NumberField = function (props) {
  var field = props.field,
    value = props.value,
    onChange = props.onChange,
    tracker = props.tracker,
    errors = props.errors;
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(label_1.Label, __assign({}, props)), react_1.default.createElement("input", {
    type: "number",
    className: field.model.cssClass,
    id: field.valueField.id,
    name: field.valueField.name,
    value: value,
    step: field.model.max,
    min: field.model.min,
    max: field.model.max,
    onChange: function (e) {
      return handleOnChange(field, e.target.value, onChange);
    },
    onFocus: function () {
      return tracker.onFocusField(field, value);
    },
    onBlur: function () {
      return tracker.onBlurField(field, value, errors);
    }
  }), react_1.default.createElement(field_validation_errors_1.FieldValidationErrors, __assign({}, props)));
};
function handleOnChange(field, fieldValue, callback) {
  var valid = true;
  var errorMessages = [];
  // custom client validation logic here
  if (field.model.required && !fieldValue) {
    valid = false;
    errorMessages.push(field.model.title + " is required");
  }
  callback(field.valueField.name, fieldValue, valid, errorMessages);
}
exports.default = NumberField;